<template>
  <div class="possword-page">
    <div class="page-title">
      <span>找回密码</span>
    </div>
    <div class="steps-box">
      <hll-steps :steps-list="['验证账户', '重置密码', '找回成功']" :step-index="curStep"></hll-steps>
    </div>
    <div class="from-box large-form" v-show="curStep === 0">
      <el-form ref="passwordForm1"
               :model="editInfo"
               label-width="0">
        <el-form-item label="" prop="reg_mobile" :rules="rules.reg_mobile">
          <el-input v-model="editInfo.reg_mobile" maxlength="11" clearable placeholder="请输入手机号">
            <i slot="prefix" class="input-icon input-icon-phone"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="" prop="captcha_code" :rules="rules.code" class="input-code-item">
          <el-input v-model="editInfo.captcha_code" maxlength="4" clearable placeholder="图片验证码">
            <i slot="prefix" class="input-icon input-icon-shield"></i>
          </el-input>
          <div class="input-code-box">
            <img :src="codeImg" class="pointer" @click="getImgCode" v-if="codeImg"/>
          </div>
        </el-form-item>
        <el-form-item label="" prop="sms_code" :rules="rules.code" class="input-code-item">
          <el-input v-model="editInfo.sms_code" maxlength="4" clearable placeholder="请输入验证码">
            <i slot="prefix" class="input-icon input-icon-password"></i>
          </el-input>
          <div class="input-code-box text-warning pointer" @click="getSmsCode">
            {{ smsTimer === 0 ? '获取验证码' : `${smsTimer}s后重试` }}
          </div>
        </el-form-item>
      </el-form>
      <el-button class="submit-btn" @click="nextStepClick">下一步</el-button>
    </div>
    <div class="from-box large-form small-space" v-show="curStep === 1">
      <el-form ref="passwordForm2"
               :model="editInfo"
               :rules="rules"
               label-position="left"
               label-width="100px">
        <input type="password" class="hide-input">
        <el-form-item label="设置密码" prop="password" :rules="rules.password">
          <el-input v-model="editInfo.password" type="password" maxlength="16" clearable
                    placeholder="8~16位数字和字母组成，字母区分大小写"
                    autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password_confirmation" :rules="rules.password_confirmation">
          <el-input v-model="editInfo.password_confirmation" type="password" maxlength="16" clearable
                    placeholder="请确认新密码" autocomplete="new-password"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="submit-btn" @click="nextStepClick">下一步</el-button>
    </div>
    <div class="from-box text-center" v-show="curStep === 2">
      <div class="result-box text-left">
        <div class="result-titlte">密码重置成功</div>
        <div class="result-tips">请牢记您的新密码！</div>
      </div>
      <el-button class="submit-btn" @click="goLogin">返回登录界面</el-button>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import md5 from 'md5'
import HllSteps from '../common/hll-steps'

export default {
  name: 'password',
  data() {
    let phoneCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'));
      } else if (value && !this.$config.regCommon.phone.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        this.isRegister(this.editInfo.reg_mobile).then(res => {
          if (res.ret === 0) { // 操作成功
            if (res.data) { // 返回 true，说明已注册
              callback();
            } else { // 返回false, 说明未注册
              callback(new Error('该手机号码尚未注册，请检查'));
            }
          } else {
            callback(new Error('账号验证失败'));
          }
        }).catch(e => {
          callback(e.msg);
        })
      }
    }
    let passwordCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'));
      } else if (value && !this.$config.regCommon.password.test(value)) {
        callback(new Error('密码长度为8~12位，支持数字和大小写字母'));
      } else {
        callback();
        // 密码验证通过 判断二次确认的密码是否存在 若存在 则触发校验
        if (this.editInfo.password_confirmation) {
          this.$refs.passwordForm2.validateField('password_confirmation')
        }
      }
    }
    let password2Check = (rule, value, callback) => {
      if (!this.editInfo.password) {
        return callback();
      }
      if (!value) {
        callback(new Error('请再次输入密码'));
      } else if (this.editInfo.password !== value) {
        callback(new Error('两次输入的密码不一致，请检查'));
      } else {
        callback();
      }
    };
    return {
      curStep: 0,
      codeImg: '',
      codeKey: '',
      smsTimer: 0,
      editInfo: {
        reg_mobile: '',
        captcha_code: '',
        sms_code: '',
        password: '',
        password_confirmation: '',
      },
      rules: {
        reg_mobile: [
          {validator: phoneCheck, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
        password: [
          {validator: passwordCheck, trigger: 'blur'}
        ],
        password_confirmation: [
          {validator: password2Check, trigger: 'blur'}
        ],
      }
    }
  },
  components: {
    HllSteps
  },
  mounted() {
    this.getImgCode()
  },
  methods: {
    ...mapActions(['clearUserInfo']),
    goLogin() {
      this.$router.push({path: '/login'})
    },
    isRegister(info) {
      return new Promise((resolve, reject) => {
        this.$axios.get("/ajax/person/center/is/register", {
          params: {
            key: info
          }
        }).then(res => {
          resolve(res.data);
        }).catch(e => {
          reject(e);
        });
      })
    },
    // 获取图片验证码
    getImgCode() {
      this.$axios.get("/ajax/common/interface/captcha/get", {
        params: {
          type: 3 // 1为注册; 2为登陆; 3为忘记密码
        }
      }).then(res => {
        this.codeImg = res.data.data.img;
        this.codeKey = res.data.data.key;
      });
    },
    // 验证图片验证码
    checkImgCode() {
      return new Promise((resolve, reject) => {
        this.$axios.post("/ajax/common/interface/captcha/check", {
          code: this.editInfo.captcha_code,
          key: this.codeKey,
          type: 3
        }).then(res => {
          resolve();
        }).catch(e => {
          if (e.type === 1) {
            this.getImgCode();
            reject()
          } else if (e.type === 2) {
            reject()
          }
        });
      })
    },
    // 获取短信验证码
    getSmsCode() {
      if (this.isLoading || this.smsTimer !== 0) {
        return
      }
      let checkNum = 0;
      let checkError = '';
      this.$refs.passwordForm1.validateField(['reg_mobile', 'captcha_code'], error => {
        checkNum++;
        checkError += error;
        if (checkNum === 2 && !checkError) {
          this.showCommonLoading();
          this.$axios.post("/ajax/common/interface/mobile/code", {
            reg_mobile: this.editInfo.reg_mobile,
            code: this.editInfo.captcha_code,
            key: this.codeKey,
            type: 3
          }).then(res => {
            this.hideCommonLoading();
            if (res.data.ret === 0) {
              this.$message.success('短信验证码发送成功');
              this.setSmsTimer();
            }
          }).catch(e => {
            this.hideCommonLoading();
          });
        }
      })
    },
    // 验证短信验证码
    checkSmsCode() {
      return new Promise((resolve, reject) => {
        this.$axios.post("/ajax/common/interface/mobile/code/check", {
          reg_mobile: this.editInfo.reg_mobile,
          sms_code: this.editInfo.sms_code,
          type: 3
        }).then(res => {
          resolve();
        }).catch(e => {
          reject();
        });
      })
    },
    // 设置短信验证码获取倒计时
    setSmsTimer() {
      this.smsTimer = 60;
      let timerItem = setInterval(() => {
        if (this.smsTimer === 0) {
          clearInterval(timerItem)
        } else {
          this.smsTimer--
        }
      }, 1000)
    },
    // 修改密码请求
    applyPassword() {
      return new Promise((resolve, reject) => {
        this.$axios.post("/ajax/person/center/user/password/reset", {
          reg_mobile: this.editInfo.reg_mobile,
          sms_code: this.editInfo.sms_code,
          password: md5(this.editInfo.password),
          password_confirmation: md5(this.editInfo.password_confirmation),
        }).then(res => {
          this.clearUserInfo();
          resolve();
        }).catch(e => {
          if (e.type === 1) {
            this.clearUserInfo();
            reject()
          } else if (e.type === 2) {
            reject()
          }
        });
      })
    },
    // 下一步
    nextStepClick() {
      if (this.isLoading) {
        return
      }
      if (this.curStep === 0) {
        let checkNum = 0;
        let checkError = '';
        this.$refs.passwordForm1.validateField(['reg_mobile', 'sms_code'], error => {
          checkNum++;
          checkError += error;
          if (checkNum === 2 && !checkError) {
            this.$refs.passwordForm1 && this.$refs.passwordForm1.clearValidate();
            this.showCommonLoading();
            this.checkSmsCode().then(() => {
              this.hideCommonLoading();
              this.curStep++
            }).catch(() => {
              this.hideCommonLoading()
            })
          }
        })
      } else if (this.curStep === 1) {
        this.$refs.passwordForm2.validate(valid => {
          if (valid) {
            this.showCommonLoading();
            this.applyPassword().then(() => {
              this.hideCommonLoading();
              this.curStep++
            }).catch(() => {
              this.hideCommonLoading()
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.possword-page {
  width: 724px;
  margin: 55px auto;

  .page-title {
    width: 100%;
    height: 32px;
    line-height: 32px;
    font-size: 24px;
    color: #212121;
    text-align: center;
    position: relative;
  }

  .title-sub {
    position: absolute;
    right: 6px;
    top: 8px;
    font-size: 12px;
    color: #ccc;
  }

  .steps-box {
    width: 100%;
    margin-top: 68px;
  }

  .from-box {
    width: 430px;
    margin: 69px auto;
  }

  .agree-box {
    font-size: 12px;
    color: #424456;
    margin-bottom: 20px;

    span {
      vertical-align: middle;
    }
  }

  .submit-btn {
    width: 100%;
    height: 48px;
    background: #F16222;
    font-size: 18px;
    color: #fff;
    border: none;
    font-weight: normal;

    &.disabled {
      background: rgba(241, 98, 34, .35);
    }
  }

  .result-box {
    display: inline-block;
    width: auto;
    height: 80px;
    background: url("../../assets/img/account/icon_success.png") no-repeat left center;
    background-size: 80px 80px;
    padding-left: 134px;
    margin: 55px auto 110px;
    box-sizing: border-box;

    .result-titlte {
      color: #424456;
      font-size: 22px;
      line-height: 30px;
      padding-top: 10px;
      margin-bottom: 13px;
    }

    .result-tips {
      color: #919191;
      font-size: 16px;
      line-height: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/password.vue